import p1before from "../assets/gallery/patient-1-before.jpeg";
import p1after from "../assets/gallery/patient-1-after.jpeg";
import p2before from "../assets/gallery/patient-2-before.jpeg";
import p2after from "../assets/gallery/patient-2-after.jpg";
import p3before from "../assets/gallery/patient-3-before.jpg";
import p3after from "../assets/gallery/patient-3-after.jpg";
import p4before from "../assets/gallery/patient-4-before.jpg";
import p4after from "../assets/gallery/patient-4-after.jpg";
import p5before from "../assets/gallery/patient-5-before.jpg";
import p5after from "../assets/gallery/patient-5-after.jpg";
import p6before from "../assets/gallery/patient-6-before.jpg";
import p6after from "../assets/gallery/patient-6-after.jpg";
import p7before from "../assets/gallery/patient-7-before.jpg";
import p7after from "../assets/gallery/patient-7-after.jpg";
import p8before from "../assets/gallery/patient-8-before.jpg";
import p8after from "../assets/gallery/patient-8-after.jpg";
import p9before from "../assets/gallery/patient-9-before.jpg";
import p9after from "../assets/gallery/patient-9-after.jpg";

/* Filter vocabularies --------------------------------------------------------*/

// Buckets by upper limit. 5,000 exactly falls in "4,100–5,000"; "5,000+" means above 5,000.
export const GRAFT_RANGES = [
  { value: "1000-2000", label: "1,000–2,000", max: 2000 },
  { value: "2100-3000", label: "2,100–3,000", max: 3000 },
  { value: "3100-4000", label: "3,100–4,000", max: 4000 },
  { value: "4100-5000", label: "4,100–5,000", max: 5000 },
  { value: "5000+", label: "5,000+", max: Infinity },
];

export const AREA_OPTIONS = ["Frontal hairline", "Temples", "Crown", "Mid-scalp", "Full scalp"];
export const TECHNIQUE_OPTIONS = ["Sapphire FUE", "DHI", "FUE", "FUT"];
export const TIMELINE_OPTIONS = ["3–6 months", "6–9 months", "9–12 months", "12+ months"];

export const getGraftRange = (grafts) =>
  typeof grafts === "number" ? GRAFT_RANGES.find((r) => grafts <= r.max) : undefined;

/* Patients -------------------------------------------------------------------*/

const raw = [
  { id: 1, grafts: 3500, technique: "Sapphire FUE", before: p1before, after: p1after },
  { id: 2, grafts: 4000, technique: "DHI", before: p2before, after: p2after },
  { id: 3, grafts: 3200, technique: "Sapphire FUE", before: p3before, after: p3after },
  { id: 4, grafts: 4500, technique: "DHI", before: p4before, after: p4after },
  { id: 5, grafts: 3800, technique: "Sapphire FUE", before: p5before, after: p5after },
  { id: 6, grafts: 3000, technique: "FUT", before: p6before, after: p6after },
  { id: 7, grafts: 4200, technique: "DHI", before: p7before, after: p7after },
  { id: 8, grafts: 3600, technique: "Sapphire FUE", before: p8before, after: p8after },
  { id: 9, grafts: 2800, technique: "FUE", before: p9before, after: p9after },
];

export const results = raw.map((p) => ({
  area: null, //     e.g. "Frontal hairline"  (fill in only if verified)
  timeline: null, // e.g. "6–9 months"        (fill in only if verified)
  ...p,
  label: `Patient ${String(p.id).padStart(2, "0")}`,
}));

/* Filtering ------------------------------------------------------------------*/

export const EMPTY_FILTERS = { graft: [], area: [], technique: [], timeline: [] };

const GROUP_DEFS = [
  { key: "graft", label: "Graft range", tabLabel: "Graft range", options: GRAFT_RANGES.map((r) => ({ value: r.value, label: r.label })), getValue: (r) => getGraftRange(r.grafts)?.value },
  { key: "area", label: "Treatment area", tabLabel: "Treatment area", options: AREA_OPTIONS.map((v) => ({ value: v, label: v })), getValue: (r) => r.area },
  { key: "technique", label: "Procedure type", tabLabel: "Hair transplant technique", options: TECHNIQUE_OPTIONS.map((v) => ({ value: v, label: v })), getValue: (r) => r.technique },
  { key: "timeline", label: "Result timeline", tabLabel: "Result timeline", options: TIMELINE_OPTIONS.map((v) => ({ value: v, label: v })), getValue: (r) => r.timeline },
];

/** Only groups/options that real patient data supports (with counts). */
export function buildFilterGroups(list) {
  return GROUP_DEFS.map((g) => ({
    key: g.key,
    label: g.label,
    tabLabel: g.tabLabel,
    options: g.options
      .map((o) => ({ ...o, count: list.filter((r) => g.getValue(r) === o.value).length }))
      .filter((o) => o.count > 0),
  })).filter((g) => g.options.length > 0);
}

/** AND across groups, OR within a group. */
export function matchesFilters(result, filters) {
  return GROUP_DEFS.every((g) => {
    const selected = filters[g.key];
    return !selected || selected.length === 0 || selected.includes(g.getValue(result));
  });
}